module.exports = __webpack_public_path__ + "static/media/gear.c2508184.svg";